import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Guía de Polarizado Automotor',
    image: 'https://cdn.magicpatterns.com/uploads/i8nSEoRmR2muYifXJxGa4m/Bono_1.png'
  }, {
    title: 'Guía de Ploteo Automotor',
    image: 'https://cdn.magicpatterns.com/uploads/f3P8LEwVqMbRVWd85CsSnM/Bono_2.png'
  }, {
    title: 'Guía Completa de Mecánica Automotor',
    image: 'https://cdn.magicpatterns.com/uploads/pvm2Ry8ofBWF1pNsAMnUTp/Bono_3.png'
  }, {
    title: 'Guía para Presupuestar Detailing Automotriz',
    image: 'https://cdn.magicpatterns.com/uploads/scPzeDmfHboRU2hap9j4RT/Bono_4.png'
  }, {
    title: 'Emprendé en Detallado Automotor',
    image: 'https://cdn.magicpatterns.com/uploads/9gQHxvE1KsBmN6oyGQEm4N/Bono_5.png'
  }];
  return <section className="py-20 px-4 bg-gradient-to-b from-[#0a0a0a] to-[#111] pt-[44px] pb-[44px]" data-id="element-16">
      <div className="max-w-6xl mx-auto pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[0px] mr-[0px]" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-18">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-19">
            + 5 BONOS <span className="text-brand-yellow" data-id="element-20">INCLUIDOS</span>
          </h2>

          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#F5C518] via-[#FFD700] to-[#F5C518] px-5 py-2 rounded-full shadow-[0_0_20px_rgba(245,197,24,0.3)] animate-pulse-glow" data-id="element-21">
            <Sparkles className="w-4 h-4 text-black/80" data-id="element-22" />
            <p className="text-sm md:text-base font-black text-black uppercase tracking-wider whitespace-nowrap" data-id="element-23">
              GRATIS POR EL DÍA DE HOY
            </p>
            <Sparkles className="w-4 h-4 text-black/80" data-id="element-24" />
          </div>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-25">
          {bonuses.map((bonus, index) => <motion.a key={index} href="#compra" onClick={e => {
          e.preventDefault();
          document.querySelector('#compra')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group cursor-pointer" data-id="element-26">
              <div className="bg-[#1a1a1a] rounded-2xl overflow-hidden border border-gray-800 hover:border-brand-yellow/50 transition-all duration-300 shadow-lg hover:shadow-brand-yellow/20 hover:scale-105" data-id="element-27">
                {bonus.image ? <div className="aspect-[3/4] overflow-hidden flex items-center justify-center bg-[#111]" data-id="element-28">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500 p-4" data-id="element-29" />
                  </div> : <div className="aspect-square bg-gradient-to-br from-brand-yellow/20 to-brand-gold/10 flex items-center justify-center" data-id="element-30">
                    <Sparkles className="w-24 h-24 text-brand-yellow" data-id="element-31" />
                  </div>}
                <div className="p-6" data-id="element-32">
                  <div className="flex items-start gap-3" data-id="element-33">
                    <div className="bg-green-500 text-white text-xs font-black px-3 py-1.5 rounded-full flex-shrink-0 mt-1" data-id="element-34">
                      BONO {index + 1}
                    </div>
                    <p className="text-lg font-bold text-white leading-tight" data-id="element-35">
                      {bonus.title}
                    </p>
                  </div>
                </div>
              </div>
            </motion.a>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-r from-brand-yellow/10 via-brand-gold/10 to-brand-yellow/10 py-8 px-6 rounded-3xl border border-brand-yellow/30" data-id="element-36">
          <p className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-37">
            👉 Todo lo que necesitás para{' '}
            <span className="text-brand-yellow" data-id="element-38">empezar y crecer</span>
          </p>
        </motion.div>
      </div>
    </section>;
}